package com.shadowings.gero.domain.reminder

import androidx.compose.runtime.Composable

@Composable
actual fun NotificationPermissionRequestEffect(
    triggerRequest: Boolean,
    onRequestHandled: () -> Unit,
    onPermissionResult: (Boolean) -> Unit,
) {
    if (triggerRequest) {
        onRequestHandled()
        onPermissionResult(false)
    }
}

@Composable
actual fun rememberNotificationPermissionGranted(): Boolean = false

actual fun openNotificationPermissionSettings() = Unit
